const multimediaEndpoints = {
  base: '/v1/cms/multimedia',
  importUrl: '/v1/cms/multimedia/import-url',
  byId: (id) => `/v1/cms/multimedia/${id}`
};

export default multimediaEndpoints;
